<div class="container-xl">
    <app-breadcrumb [crumbs]="crumbs"></app-breadcrumb>
    <app-checkpoint-header [checkpoint]="checkpoint()" [platform]="platform()"></app-checkpoint-header>
    <div class="row gap-2">
        <div class="col-12">
            <div class="row">
                <div class="col-3">Platform</div>
                <div class="col">{{platform().name}}</div>
            </div>
        </div>
        <div class="col-12">
            <div [class.text-danger]="checkpointResult().response_status_code === CurlErrorCodesEnum.couldNotResolveHost" class="row">
                <div class="col-3">Checkpoint</div>
                <div class="col">{{checkpoint().name}}</div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Startdatum</div>
                <div class="col">
                    {{checkpointResult().start_date | date: 'EEE d MMM HH:mm:ss'}}
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Afrondingsdatum</div>
                <div class="col">
                    {{(checkpointResult().finish_date | date: 'EEE d MMM HH:mm:ss') ?? '-'}}
                </div>
            </div>
        </div>
        <div class="col-12">
            <div
                [class.text-danger]="checkpointResult().error"
                [class.text-warning]="!checkpointResult().error && checkpointResult().warning"
                class="row align-items-center">
                <div class="col-3">Status</div>
                <div class="col">
                    <div [class]="checkpointResult() | CheckpointResultLevelStatusPipe"></div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Statuscode</div>
                <div class="col">{{checkpointResult().response_status_code}}</div>
            </div>
        </div>
        <div class="col-12">
            <div [class.text-danger]="checkpointResult().result === checksumMismatch" class="row">
                <div class="col-3">Hash</div>
                <div class="col">{{checkpointResult().hash ?? '-'}}</div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Resultaat</div>
                <div class="col">{{checkpointResult().result}}</div>
            </div>
        </div>
        <div class="col-12">
            <div
                [class.text-danger]="((checkpointResult().result === minRespTime ||checkpointResult().result === maxRespTime) && checkpointResult().error) || checkpointResult().response_status_code === CurlErrorCodesEnum.timeout"
                [class.text-warning]="(checkpointResult().result === minRespTime || checkpointResult().result === maxRespTime) && checkpointResult().warning"
                class="row">
                <div class="col-3">Duratie</div>
                <div class="col">{{checkpointResult().duration ?? 0}} ms</div>
            </div>
        </div>
        <div class="col-12">
            <div
                [class.text-danger]="(checkpointResult().result === minContSize || checkpointResult().result === maxContSize) && checkpointResult().error"
                [class.text-warning]="(checkpointResult().result === minContSize || checkpointResult().result === maxContSize) && checkpointResult().warning"
                class="row">
                <div class="col-3">Grootte</div>
                <div class="col">{{checkpointResult().size | bytesPipe}}</div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Herhaal poging id</div>
                <div class="col">{{checkpointResult().retry_id ?? '-'}}</div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Job id</div>
                <div class="col">{{checkpointResult().job_id}}</div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Aangemaakt op</div>
                <div class="col">
                    {{checkpointResult().created_at | date: 'EEE d MMM HH:mm:ss'}}
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div class="col-3">Inhoud</div>
                <div class="col">
                    <pre class="json-codeblock p-2">{{checkpointResult().checkpoint_results_content?.content | formatResponseText}}</pre>
                </div>
            </div>
        </div>
    </div>
</div>
